import React from 'react'
import { obtenermovpercepcion, obtenermovdeduccion, obtenermovmov } from '../../Redux/PdimIncidenciasDucks'
import DetallesPercepcionImporte from './incidenciasregistro/AltaIncidencias/Percepcion/DetallesPercepcionImporte'
import DetallesPercepcionFechas from './incidenciasregistro/AltaIncidencias/Percepcion/DetallesPercepcionFechas'
import DetallePrestamo from './incidenciasregistro/AltaIncidencias/Deduccion/DetallePrestamo'
import DetalleHorasExtra from './incidenciasregistro/AltaIncidencias/Incidencias/DetalleHorasExtra'
import DetalleIncidenciaFechas from './incidenciasregistro/AltaIncidencias/Incidencias/DetalleIncidenciaFechas'
import DetallesIncidenciaFechaHora from './incidenciasregistro/AltaIncidencias/Incidencias/DetallesIncidenciaFechaHora'
import DetallesMovFecha from './incidenciasregistro/AltaIncidencias/Movimientos/DetallesMovFecha'
import DetallesIncidenciasIncrementoSalario from './incidenciasregistro/AltaIncidencias/Incidencias/DetallesIncidenciasIncrementoSalario'
import DetallesAccidenteTrabajo from './incidenciasregistro/AltaIncidencias/Incidencias/DetallesAccidenteTrabajo'
import DetallesEfer140Mater from './incidenciasregistro/AltaIncidencias/Incidencias/DetallesEfer140Mater'

const SwitchTipoIncidencias = (props) => {
    const { subtipo } = props
    const { data } = props



    switch (subtipo) {
        case 'Día festivo / descanso':
            return (
                <>
                    <DetallesPercepcionFechas
                        idmovimiento={data.idmovtopdo}
                        data={data}
                        obtener={obtenermovpercepcion(data.idmovtopdo)}
                    />
                </>
            )

        case 'Gratificación':
            return (
                <>
                    <DetallesPercepcionImporte
                        idmovimiento={data.idmovtopdo}
                        data={data}
                        obtener={obtenermovpercepcion(data.idmovtopdo)}
                    />
                </>
            )

        case 'Compensación':
            return (
                <>
                    <DetallesPercepcionImporte
                        idmovimiento={data.idmovtopdo}
                        data={data}
                        obtener={obtenermovpercepcion(data.idmovtopdo)}
                    />
                </>
            )

        case 'Préstamo empresa':
            return (
                <>
                    <DetallePrestamo
                        idmovimiento={data.idmovtopermanente}
                        data={data}
                        obtener={obtenermovdeduccion(data.idmovtopermanente)}
                    />
                </>
            )

        case 'Horas extras 1':
            return (
                <>
                    <DetalleHorasExtra
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Horas extras 2':
            return (
                <>
                    <DetalleHorasExtra
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Horas extras 3':
            return (
                <>
                    <DetalleHorasExtra
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Horas extras 4':
            return (
                <>
                    <DetalleHorasExtra
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Horas extras 5':
            return (
                <>
                    <DetalleHorasExtra
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Permisos con goce de sueldo':
            return (
                <>
                    <DetalleIncidenciaFechas
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Permisos sin goce de sueldo':
            return (
                <>
                    <DetalleIncidenciaFechas
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Accidente de trabajo':
            return (
                <>
                    <DetallesAccidenteTrabajo
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Enf. Gral./Acc. Fuera trab.':
            return (
                <>
                    <DetallesEfer140Mater
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )
        case 'Licencia 140 Bis':
            return (
                <>
                    <DetallesEfer140Mater
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )
        case 'Incapacidad por maternidad':
            return (
                <>
                    <DetallesEfer140Mater
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )
        case 'Faltas injustificadas':
            return (
                <>
                    <DetalleIncidenciaFechas
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Retardos':
            return (
                <>
                    <DetallesIncidenciaFechaHora
                        idmovimiento={data.idmovtosdyh}
                        data={data}
                    />
                </>
            )

        case 'Baja':
            return (
                <>
                    <DetallesMovFecha
                        idmovimiento={data.idmovimiento}
                        data={data}
                        obtener={obtenermovmov(data.idmovimiento)}
                    />
                </>
            )

        case 'Reingreso':
            return (
                <>
                    <DetallesMovFecha
                        idmovimiento={data.idmovimiento}
                        data={data}
                        obtener={obtenermovmov(data.idmovimiento)}
                    />
                </>
            )

        case 'Incremento salario':
            return (
                <>
                    <DetallesIncidenciasIncrementoSalario
                        idmovimiento={data.idmovimiento}
                        data={data}
                        obtener={obtenermovmov(data.idmovimiento)}
                    />
                </>
            )

        default:
            break;
    }

}

export default SwitchTipoIncidencias
